import NewGivingFormDialog from './NewGivingFormDialog';

export default NewGivingFormDialog;
